export default "__VITE_ASSET__CA3YMvMf__"